import { Card } from "@/app/admin/_common/ui/card";

export default function GuestNotesCard({ guest }: { guest: any }) {
  return (
    <Card className="rounded-none border-0 px-2 py-4 shadow-none md:rounded-md md:border md:px-4">
      <div className="mb-5 text-[16px] font-semibold text-foreground sm:mb-3 sm:text-[13.5px]">Notes</div>
      <div className="whitespace-pre-wrap rounded-md bg-muted/40 p-3 text-[13px] text-foreground">
        {guest.notes || <span className="text-muted-foreground">No notes yet</span>}
      </div>
    </Card>
  );
}
